import { Settings } from 'lucide-react'
import { SettingsList } from '@components/settings/SettingsList'
import { useSettings } from '@hooks/useSettings'

export function SettingsPage() {
  const { data: settings, isLoading, error } = useSettings()

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="text-center">
          <div className="mb-4 inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-primary border-r-transparent"></div>
          <p className="text-gray-600">Loading settings...</p>
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="rounded-lg border border-red-200 bg-red-50 p-6 text-center">
        <p className="text-red-800">
          Failed to load settings. {error instanceof Error ? error.message : 'Please try again.'}
        </p>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Settings size={32} className="text-primary" />
          <h1 className="text-3xl font-bold text-gray-900">System Settings</h1>
        </div>
        <div className="text-sm text-gray-500">
          {settings?.length || 0} {settings?.length === 1 ? 'setting' : 'settings'}
        </div>
      </div>

      <SettingsList settings={settings || []} />
    </div>
  )
}
